import { Link } from 'react-router-dom';
import { KeenIcon } from '@/components/keenicons';
// import { toAbsoluteUrl } from '@/utils';
import { useDemo1Layout } from '../';
import horizonalUniLogo from '@/assets/images/horizonal-uni-logo.svg'
const HeaderLogo = () => {
  const {
    setMobileSidebarOpen,
    setMobileMegaMenuOpen,
    megaMenuEnabled
  } = useDemo1Layout();
  const handleSidebarOpen = () => {
    setMobileSidebarOpen(true);
  };
  const handleMegaMenuOpen = () => {
    setMobileMegaMenuOpen(true);
  };
  return <div className="flex gap-1 lg:hidden items-center -ms-1">
      <div className="flex items-center">
        <button type="button" className="btn btn-icon btn-light btn-clear btn-sm" onClick={handleSidebarOpen}>
          <KeenIcon icon="menu" />
        </button>

        {megaMenuEnabled && <button type="button" className="btn btn-icon btn-light btn-clear btn-sm" onClick={handleMegaMenuOpen}>
            <KeenIcon icon="burger-menu-2" />
          </button>}
      </div>
      <Link to="/" className="shrink-0">
        {/* <img src={toAbsoluteUrl('/media/app/mini-logo.svg')} className="max-h-[25px] w-full" alt="mini-logo" /> */}
        <img src={"/media/images/logo_ngang.png"} className="max-h-[30px] w-full" alt="mini-logo" />
      </Link>
    </div>;
};
export { HeaderLogo };